import React from 'react';
import dayjs from 'dayjs';

import * as M from 'styles/mobile';
import { IOrganization } from 'types';
import * as S from './style';

interface Props {
  data: IOrganization[];
  isLoading?: boolean;
}

function MobileList({ data, isLoading }: Props) {
  return (
    <div css={M.list}>
      {data.map((org) => (
        <div key={org.id} css={[M.listItemStatic, S.row]}>
          {org.logoUrl ? (
            <img css={S.logo} src={org.logoUrl} alt={org.displayName} />
          ) : (
            <div css={S.logo} />
          )}
          <div css={S.info}>
            <div css={M.listRow}>
              <p css={S.title}>{org.displayName}</p>
              <span css={M.listDate}>
                {dayjs(org.createdAt).format('YYYY-MM-DD')}
              </span>
            </div>
            <p css={S.meta}>
              {org.name}
              {org.description && ` · ${org.description}`}
            </p>
          </div>
        </div>
      ))}
      {!isLoading && data.length === 0 && (
        <p css={M.empty}>등록된 단체가 없습니다</p>
      )}
    </div>
  );
}

export default MobileList;
